import { ArgsType, Field, Int } from '@nestjs/graphql'

import { BaseUpdateDto } from '../../base/baseUpdate.dto'

@ArgsType()
export class UpdateUserStatusDto extends BaseUpdateDto<UpdateUserStatusDto> {
  @Field(t => Int, { nullable: true })
  type?: number

  @Field({ nullable: true })
  active?: boolean

  @Field({ nullable: true })
  isRestriction?: boolean

  @Field({ nullable: true })
  expiryDate?: Date

  @Field({ nullable: true })
  additionalInformation?: string

  @Field(t => Int)
  userId!: number

  @Field(t => Int, { nullable: true })
  ineligibleReason?: number
}
